import { ele, helper } from "cables-shared-client";

import api from "./api.js";
import web from "./index.js";

export default class PatchLists
{
    displayPatchList(targetEl, fromUserInteraction = false, listId = null, cb = null)
    {
        const listTarget = targetEl || ele.byId("patchlist");
        const id = listId || listTarget.dataset.listId;
        const editMode = listTarget && listTarget.dataset.editMode ? listTarget.dataset.editMode : false;
        const isStaff = listTarget && listTarget.dataset.editStaff ? listTarget.dataset.editStaff : false;

        api.get("patchlists/" + id, (result) =>
        {
            const list = result.data;
            let template = "patchlist_info";
            if (editMode)
            {
                template = "patchlist_edit";
            }
            list.allProjectIds = "";
            if (list.allowExport)
            {
                list.projects.forEach((project, i) =>
                {
                    if (i > 0) list.allProjectIds += ",";
                    list.allProjectIds += project.shortId;
                });
            }
            const projects = list.projects;
            let listHtml = "";
            if (projects.length > 0)
            {
                for (let i = 0; i < projects.length; i++)
                {
                    const project = projects[i];
                    const projectInfo = web.getHandleBarHtml("project_info", {
                        "project": project,
                        "user": {
                            "_id": project.userId,
                            "username": project.cachedUsername
                        }
                    });
                    const vars = {
                        "project": project,
                        "list": list,
                        "first": i === 0,
                        "last": i === (projects.length - 1),
                        "editMode": editMode,
                        "projectInfo": projectInfo
                    };
                    listHtml += web.getHandleBarHtml("patchlist_item", vars);
                }
            }
            else
            {
                const vars = {
                    "list": list,
                    "last": true,
                    "editMode": editMode
                };
                listHtml += web.getHandleBarHtml("patchlist_item", vars);
            }
            if (list.allowEdit) listHtml += web.getHandleBarHtml("patchlist_add_patch", { "list": list });

            if (listTarget)
            {
                const container = document.createElement("div");
                container.classList.add("row");
                const infoContainer = document.createElement("div");
                infoContainer.classList.add("cute-4-tablet", "left");
                web.setHandleBarHtml(template, {
                    "list": list,
                    "editMode": editMode,
                    "hasEditRights": list.allowEdit,
                    "hasExportRights": list.allowExport,
                    "isStaff": isStaff
                }, infoContainer);
                container.appendChild(infoContainer);

                const listContainer = document.createElement("div");
                listContainer.classList.add("patchlisttable", "cute-8-tablet", "right");
                listContainer.dataset.listId = list._id;
                listContainer.innerHTML = listHtml;

                container.appendChild(listContainer);
                listTarget.innerHTML = container.outerHTML;
                web.tabs.initPagination(listTarget, result.pagination);

                ele.clickables(listTarget, ".clickable", (event, dataset) =>
                {
                    if (dataset.click === "export")
                    {
                        const fileURL = "/api/projects/" + list.allProjectIds + "/export_code" + "?fileName=" + list.exportName;
                        window.open(fileURL);
                    }
                });
                if (cb) cb();
            }
        });
    }

    create()
    {
        api.post("patchlists/create", {}, (res) =>
        {
            document.location.href = "/patchlist/" + res.data.shortId + "/edit#settings";
        });
    }

    delete(listId)
    {
        if (confirm("Really delete ?"))
        {
            api.delete("patchlists/" + listId, {}, (res) =>
            {
                window.location.reload();
            });
        }
    }

    addItem(listId, id, type, cb)
    {
        const errorEle = ele.byId("addpatch-error");
        if (id)
        {
            let url = "patchlists/" + listId + "/projects/" + id;
            if (type === "op") url = "patchlists/" + listId + "/ops/" + id;
            api.post(url, {}, () =>
            {
                if (errorEle) ele.hide(errorEle);
                if (cb) cb();
            }, (e) =>
            {
                web.buttons.stopSavingAnimButton(false, false);
                if (errorEle)
                {
                    errorEle.innerText = "Adding not possible: \"" + e.msg + "\"";
                    ele.show(errorEle);
                }
            });
        }
        else
        {
            web.buttons.stopSavingAnimButton(false, false);
            if (errorEle)
            {
                errorEle.innerText = "- Unknown list or insufficient permissions";
                ele.show(errorEle);
            }
        }
    }

    removeItem(listId, id, type, showConfirm, cb)
    {
        let r = true;
        if (showConfirm) r = confirm("are you sure? remove " + type + "?");
        if (r)
        {
            let url = "patchlists/" + listId + "/projects/" + id;
            if (type === "op") url = "patchlists/" + listId + "/ops/" + id;
            api.delete(url, {}, (response) =>
            {
                if (cb) cb();
            }, (e) =>
            {
                web.buttons.stopSavingAnimButton(false, false);
                const errorEle = ele.byId("patch-error");
                if (errorEle)
                {
                    const target = errorEle.querySelector(".warn-hint");
                    if (target) target.innerText = "- removal not possible: \"" + e.msg + "\"";
                    ele.show(errorEle);
                }
            });
        }
    }

    getAll(targetEl, fromUserInteraction)
    {
        const filter = targetEl.dataset.contentFilter;
        const template = targetEl.dataset.contentTemplate || "patchlist";
        const type = targetEl.dataset.contentType || "default";

        let apiUrl = "patchlists/all?type=" + type;
        if (filter) apiUrl += "&filter=" + filter;

        const limit = template === "patchlist_row" ? 20 : 48;
        apiUrl = web.tabs.addPagination(apiUrl, limit);
        api.get(apiUrl, (res) =>
        {
            let html = "";
            if (res.data.length > 0)
            {
                html = "<table>";
                res.data.forEach((list) =>
                {
                    const projectInfo = web.getHandleBarHtml("project_info", {
                        "project": list,
                        "user": list.owner,
                        "isPatchlist": true
                    });
                    html += web.getHandleBarHtml(template, {
                        "list": list,
                        "projectInfo": projectInfo
                    });
                });
                html += "</table>";
            }
            else
            {
                html = web.getHandleBarHtml("patchlist_empty");
            }
            targetEl.innerHTML = html;
            web.tabs.initPagination(targetEl, res.pagination, res.pagination.limit, res.pagination.offset);
        }, () => {});
    }

    getLists(targetEl, fromUserInteraction)
    {
        let filter = targetEl.dataset.contentFilter;
        let listUserId = targetEl.dataset.listUser;

        if (!filter) filter = "all";
        let apiUrl = web.tabs.addPagination("patchlists/mylists/" + filter, 48);
        if (listUserId) apiUrl += "&userId=" + listUserId;

        let displayedDate = "updated";
        if (filter === "profile") displayedDate = "published";

        api.get(apiUrl, (res) =>
        {
            let html = "";
            if (res.data.length > 0)
            {
                html = "<table>";
                res.data.forEach((list) =>
                {
                    const projectInfo = web.getHandleBarHtml("project_info", {
                        "project": list,
                        "user": {
                            "_id": list.owner._id,
                            "username": list.owner.username
                        },
                        "displayedDate": displayedDate,
                        "isPatchlist": true
                    });
                    html += web.getHandleBarHtml("patchlist", {
                        "list": list,
                        "projectInfo": projectInfo
                    });
                });
                html += "</table>";
            }
            else
            {
                html = web.getHandleBarHtml("patchlist_empty");
            }
            targetEl.innerHTML = html;
            web.tabs.initPagination(targetEl, res.pagination);
        }, () => {});
    }

    updateList(button, isStaff)
    {
        web.buttons.startSavingAnimButton(button);

        const id = ele.byId("list-id").value;
        const name = ele.byId("list-name").value;
        const description = ele.byId("list-description").value;
        const visibility = ele.byId("list-visibility").value;
        let sortPosition = ele.byId("list-position") ? ele.byId("list-position").value : 0;
        if (sortPosition && !helper.isNumeric(sortPosition)) sortPosition = 0;
        sortPosition = Number(sortPosition);
        if (sortPosition < 0) sortPosition = 0;

        let type = "default";
        const typeEle = ele.byId("list-type");
        if (typeEle) type = typeEle.value;

        let key = "";
        const keyEle = ele.byId("list-key");
        if (keyEle) key = keyEle.value;

        const newSettings = {
            "name": name,
            "description": description,
            "visibility": visibility,
            "sortPosition": sortPosition || 0
        };

        if (isStaff)
        {
            newSettings.type = type;
            newSettings.key = key;
        }

        api.patch(
            "patchlists/" + id, newSettings, (res) =>
            {
                web.buttons.stopSavingAnimButton(button);
                if (res.data && res.data.key)
                {
                    window.location.href = "/patchlist/" + res.data.key + "/edit";
                }
                else
                {
                    window.location.href = "/patchlist/" + res.data._id + "/edit";
                }
            }, (res) =>
            {
                web.buttons.stopSavingAnimButton(button, true, true);
                this.showError(res.data.errors);
            });
    }

    showError(errors)
    {
        let msg = "";
        for (let i = 0; i < errors.length; i++)
        {
            msg += "<li>" + errors[i] + "</li>";
        }
        let html = "<ul>" + msg + "</ul>";

        const errorEle = ele.byId("errors");
        if (errorEle)
        {
            errorEle.innerHTML = html;
            ele.show(errorEle);
        }
    }

    moveUp(buttonEl)
    {
        const listItem = buttonEl.closest(".patchlistitem");
        if (!listItem) return;
        const list = listItem.closest(".patchlisttable");
        if (!list) return;
        const sortables = Array.from(list.querySelectorAll(".patchlistitem"));
        const itemIndex = sortables.findIndex((s) => { return s.dataset.patchId === listItem.dataset.patchId; });
        const newIndex = Math.max(0, itemIndex - 1);
        listItem.classList.remove("last");

        if (newIndex === 0)
        {
            listItem.classList.add("first");
            if (sortables[newIndex]) sortables[newIndex].classList.remove("first");
        }
        if (newIndex === sortables.length - 2)
        {
            if (sortables[newIndex]) sortables[newIndex].classList.add("last");
        }
        list.insertBefore(listItem, sortables[newIndex]);

        const patchIds = Array.from(list.querySelectorAll(".patchlistitem")).map((item) => { return item.dataset.patchId; });
        api.post("patchlists/" + list.dataset.listId + "/reorder", { "projectIds": patchIds });
    }

    moveDown(buttonEl)
    {
        const listItem = buttonEl.closest(".patchlistitem");
        if (!listItem) return;
        const list = listItem.closest(".patchlisttable");
        if (!list) return;
        const sortables = Array.from(list.querySelectorAll(".patchlistitem"));
        const itemIndex = sortables.findIndex((s) => { return s.dataset.patchId === listItem.dataset.patchId; });
        const newIndex = Math.min(sortables.length, itemIndex + 1);
        listItem.classList.remove("first");

        if (newIndex === sortables.length - 1)
        {
            listItem.classList.add("last");
            if (sortables[newIndex]) sortables[newIndex].classList.remove("last");
        }
        if (newIndex === 1)
        {
            if (sortables[newIndex]) sortables[newIndex].classList.add("first");
        }
        list.insertBefore(listItem, sortables[newIndex].nextSibling);

        const patchIds = Array.from(list.querySelectorAll(".patchlistitem")).map((item) => { return item.dataset.patchId; });
        api.post("patchlists/" + list.dataset.listId + "/reorder", { "projectIds": patchIds });
    }

    setThumbnail(listId, patchId)
    {
        if (patchId)
        {
            api.post("patchlists/" + listId + "/thumbnail/" + patchId, {}, () =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            });
        }
    }

    removeThumbnail(listId)
    {
        if (listId)
        {
            api.delete("patchlists/" + listId + "/thumbnail", {}, () =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            });
        }
    }
}
